import React from 'react';

import type { Paper } from '../types';

function formatAuthors(authors: string[]) {
  if (authors.length > 2) {
    return [authors.slice(0, -1).join(', '), authors[authors.length - 1]].join(' and ');
  }
  if (authors.length === 2) {
    return authors.join(' and ');
  }
  return authors.join('');
}

export default function PaperReference({ paper }: { paper: Paper }) {
  const { link, title, authors, publication } = paper;

  return (
    <>
      <a href={link}>
        <strong>{title}</strong>
      </a>
      &nbsp;by&nbsp;
      <strong>{formatAuthors(authors)}</strong>.&nbsp;{publication}
    </>
  );
}
